import React from 'react'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/core/styles'
import i18n from '@pureartisan/simple-i18n'
import {
  Tooltip,
  Button,
  useTheme,
} from '@material-ui/core'
import shallow from 'zustand/shallow'
import useStore from './../../store'
import html2canvas from 'html2canvas'

const styles = makeStyles(theme => ({
  btn: {
    '& .MuiButton-label svg': {
      width: '66%', // '20px',
      height: '66%', // '20px',
    },
  },
}))

const ScreenshotBtn = ({ children, ...props }) => {
  const theme = useTheme()

  const { setStoreValues, eventMapCapture } = useStore(
    state => ({
      setStoreValues: state.setStoreValues,
      eventMapCapture: state.eventMapCapture,
    }),
    shallow,
  )

  const handleClick = () => {
    setStoreValues({
      eventMapCapture: eventMapCapture + 1,
    })

    return new Promise(function (resolve, reject) {
      // we trigger a render for the screenshot to avoid having to set
      // preserveDrawingBuffer: true, which may cause performance issues.
      // see: https://github.com/mapbox/mapbox-gl-js/issues/2766
      props.mapRef.once('render', function () {
        const x = theme.extras.controlPanel.width
        const y =
          theme.mixins.toolbar['@media (min-width:600px)']
            .minHeight

        html2canvas(
          document.body.querySelector('#screenshot-target'),
          {
            backgroundColor: null,
            // cleave off the part of the container obscured by header/toolbar
            x,
            y,
            scale: 2,
            width: window.innerWidth - x,
            height: window.innerHeight - y,
            onclone: (document, element) => {
              // reveal hidden elements that are for screenshot only (eg logo in legend)
              document
                .querySelectorAll('.screenshot-reveal')
                .forEach(el => (el.style.display = 'block'))

              // chart is in a Portal outside of screenshot-target: append to add (if it's open)
              const chartContainer = document.querySelector(
                '#main-chart',
              )
              if (!!chartContainer) {
                chartContainer
                  .querySelectorAll('.chart-demo-button')
                  .forEach(b => (b.style.border = 'none'))
                element.appendChild(chartContainer)
              }
            },
            ignoreElements: element => {
              // hide a few elements (map citation/controls)
              return (
                element?.classList?.contains(
                  'screenshot-ignore',
                ) ||
                element?.classList?.contains(
                  'mapboxgl-ctrl',
                )
              )
            },
          },
        ).then(canvas => {
          const a = document.createElement('a')
          a.download = 'ddk-explorer-capture.png'
          a.href = canvas.toDataURL('image/png')
          a.click()
        })
      })

      /* trigger render */
      props.mapRef.setBearing(props.mapRef.getBearing())
    })
  }
  const classes = styles()

  return (
    <Tooltip
      title={i18n.translate(`MAP_SCREENSHOT`)}
      placement={props.placement}
      arrow
    >
      <Button
        aria-label={i18n.translate(`MAP_SCREENSHOT`)}
        onClick={handleClick}
        className={clsx(
          'btn-screenshot',
          props.className,
          classes.btn,
        )}
      >
        {children}
      </Button>
    </Tooltip>
  )
}

ScreenshotBtn.propTypes = {}

export default ScreenshotBtn
